import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

const Footer = () => (
  <footer className="border-t border-white/10 bg-surface">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 py-16 sm:px-8 md:grid-cols-3 lg:px-12 lg:py-20">
      <div>
        <div data-testid="footer-logo" className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-neon font-display text-sm font-black text-canvas">
            A&O
          </span>
          <span className="font-display text-xs font-bold uppercase tracking-[0.18em] text-white">
            Asociația Art & Outdoor România
          </span>
        </div>
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-neutral-400">
          Organizație non-profit care transformă istoria și natura în experiențe
          vii pentru copii, adolescenți și tineri.
        </p>
      </div>
      <div>
        <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-neon">
          Navigare
        </p>
        <ul className="mt-5 space-y-3 text-sm">
          <li><Link to="/" data-testid="footer-link-home" className="text-neutral-400 transition-colors hover:text-neon">Acasă</Link></li>
          <li><Link to="/proiecte" data-testid="footer-link-projects" className="text-neutral-400 transition-colors hover:text-neon">Proiecte</Link></li>
          <li><Link to="/bushido-vs-bullying" data-testid="footer-link-bushido" className="text-neutral-400 transition-colors hover:text-neon">Bushido vs. Bullying</Link></li>
          <li><Link to="/rise27" data-testid="footer-link-rise27" className="text-neutral-400 transition-colors hover:text-neon">RISE 27'</Link></li>
          <li><Link to="/redirectioneaza-3-5" data-testid="footer-link-redirect" className="text-neutral-400 transition-colors hover:text-neon">Redirecționează 3,5%</Link></li>
          <li><Link to="/transparenta" data-testid="footer-link-transparency" className="text-neutral-400 transition-colors hover:text-neon">Unde ajung banii</Link></li>
          <li><Link to="/contact" data-testid="footer-link-contact" className="text-neutral-400 transition-colors hover:text-neon">Contact</Link></li>
          <li><Link to="/admin" data-testid="footer-link-admin" className="text-neutral-500 transition-colors hover:text-neon">Staff</Link></li>
          <li><Link to="/termeni-si-conditii" data-testid="footer-link-terms" className="text-neutral-500 transition-colors hover:text-neon">Termeni &amp; GDPR</Link></li>
        </ul>
      </div>
      <div>
        <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-neon">
          Urmărește-ne
        </p>
        <div data-testid="footer-social-links" className="mt-5 flex items-center gap-3">
          <a
            href="https://www.instagram.com/artandoutdoor.ro/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            data-testid="social-instagram"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 text-neutral-400 transition-all duration-300 hover:border-neon hover:text-neon"
          >
            <Instagram className="h-5 w-5" />
          </a>
          <a
            href="https://www.instagram.com/artandoutdoor.ro/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="social-instagram-handle"
            className="font-mono text-xs text-neutral-400 transition-colors hover:text-neon"
          >
            @artandoutdoor.ro
          </a>
        </div>
        <p className="mt-6 text-sm text-neutral-500">
          Cluj-Napoca · Alba Iulia, România
        </p>
        <div data-testid="footer-contact-details" className="mt-6 space-y-2 text-sm text-neutral-400">
          <p className="leading-relaxed">
            Sediu: Str. Ștefan Luchian nr. 3, ap. 10,<br />
            Alba Iulia, jud. Alba
          </p>
          <p>
            <a
              href="tel:+40762971209"
              data-testid="footer-phone"
              className="transition-colors hover:text-neon"
            >
              0762 971 209
            </a>
          </p>
          <p>
            <a
              href="mailto:contact@artandoutdoor.com"
              data-testid="footer-email"
              className="transition-colors hover:text-neon"
            >
              contact@artandoutdoor.com
            </a>
          </p>
          <p data-testid="footer-cif" className="pt-2 text-xs text-neutral-500">
            CIF: 38948024
          </p>
          <p data-testid="footer-iban" className="text-xs leading-relaxed text-neutral-500">
            IBAN: RO33 RNCB 0003 1859 9467 0001<br />
            Beneficiar: Asociația Art &amp; Outdoor România
          </p>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <p className="mx-auto max-w-7xl px-4 py-6 font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-500 sm:px-8 lg:px-12">
        © 2026 Asociația Art & Outdoor România — Organizație Neguvernamentală (ONG)
      </p>
    </div>
  </footer>
);

export default Footer;
